// import React, { useState } from "react";
// import { Box } from "@mui/material";
// import CustomModal from "../../../../components/Modals/CustomModal";
// import { fontWeight } from "../../../../utils/constants/UI";
// import { GREY, BRAND, BORDER } from "../../../../utils/constants/colors";
// import { Button } from "../../../../components/Buttons";
// import TypographyInline from "../../../../components/Typography/TypographyInline";
// import Image from "../../../../components/Image/Image";
// import classes from "../markComponents.module.css";
// import {
//   AUTOMATED_IMAGE,
//   CALL_IMAGE,
//   TODO_IMAGE,
// } from "../../../../utils/constants/assets";
// import { postRequest } from "../../../../Apis";
// import { useNavigate } from "react-router-dom";
// import { CircularProgress } from "@mui/material";
// import { sequenceEndPoints } from "../../../../utils/constants/httpConstants";
// import Checkbox from "../../../../components/Buttons/Checkbox/Checkbox";
// import EventEmitter from "../../../../utils/emitter/EventEmitter";
// import { EMITTER_SUCCESS, EMITTER_ERROR } from "../../../../utils/constants";

// const STYLES = {
//   modalBody: {
//     padding: "20px",
//   },
//   description: {
//     marginBottom: "24px",
//   },
//   cardsContainer: {
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "20px",
//   },
//   card: {
//     base: {
//       cursor: "pointer",
//       position: "relative",
//       display: "flex",
//       flexDirection: "column",
//       borderRadius: "16px",
//       border: `1px solid ${BORDER.DEFAULT}`,
//       backgroundColor: "#FFFFFF",
//       transition: "all 0.2s ease",
//       overflow: "hidden",
//     },
//     active: {
//       border: `1px solid ${BRAND.PRIMARY}`,
//       backgroundColor: "#FFFFFF",
//     },
//   },
//   checkbox: {
//     position: "absolute",
//     top: "16px",
//     right: "16px",
//     zIndex: 10,
//   },
//   iconSection: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "48px 24px 32px",
//   },
//   iconCircle: {
//     width: "120px",
//     height: "120px",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     backgroundColor: "#FFFFFF",
//   },
//   textSection: {
//     padding: "0 24px 24px",
//     textAlign: "center",
//     display: "flex",
//     flexDirection: "column",
//     gap: "8px",
//   },
//   buttonSection: {
//     padding: "0 20px 20px",
//   },
// };

// const CreateAutomation = ({ open, setOpen, handleClose, seqId }) => {
//   const [selectedOption, setSelectedOption] = useState("");
//   const [isLoadingId, setIsLoadingId] = useState("");
//   const navigate = useNavigate();

//   const automationOptions = [
//     {
//       id: "automated_email",
//       title: "Automated Email",
//       description: "Send emails automatically based on triggers",
//       iconComponent: AUTOMATED_IMAGE,
//       bgColor: "#FEFEFE",
//     },
//     {
//       id: "call",
//       title: "Call",
//       description: "Create automated call tasks and reminders",
//       iconComponent: CALL_IMAGE,
//       bgColor: "#FEFEFE",
//     },
//     {
//       id: "todo",
//       title: "To-do",
//       description: "Create automated task lists and reminders",
//       iconComponent: TODO_IMAGE,
//       bgColor: "#FEFEFE",
//     },
//   ];

//   const handleSelect = (id) => {
//     setSelectedOption(id);
//   };

//   const handleGenerate = async (id) => {
//     if (!seqId) {
//       EventEmitter.emit(
//         EMITTER_ERROR,
//         "Sequence ID is missing. Please try again."
//       );
//       return;
//     }

//     setSelectedOption(id);
//     setIsLoadingId(id);

//     try {
//       const resTypeMap = {
//         automated_email: 1,
//         call: 3,
//         todo: 2,
//       };

//       const resType = resTypeMap[id];

//       const response = await postRequest(
//         navigate,
//         sequenceEndPoints.aiGenerateManualStep,
//         {
//           sequence_id: seqId,
//           res_type: resType,
//         }
//       );

//       if (response.data && response.data.success) {
//         EventEmitter.emit(EMITTER_SUCCESS, response.data.message);
//         setTimeout(() => {
//           handleClose();
//         }, 1500);
//       } else {
//         EventEmitter.emit(
//           EMITTER_ERROR,
//           "Failed to generate automation step. Please try again."
//         );
//       }
//     } catch (err) {
//       console.error("API error:", err);
//       EventEmitter.emit(
//         EMITTER_ERROR,
//         err?.data?.message ||
//           "An error occurred while generating automation step."
//       );
//     } finally {
//       setIsLoadingId("");
//     }
//   };

//   const modalHeaderData = {
//     heading: {
//       id: "automation_head",
//       label: "Create Automation",
//     },
//   };

//   const modalBodyData = (
//     <Box sx={STYLES.modalBody}>
//       <Box sx={STYLES.description}>
//         <TypographyInline
//           size={"sm"}
//           color={GREY.QUATINARY}
//           fontWeight={fontWeight.REGULAR}
//           label="Select the type of automation you want to create for your sequence"
//         />
//       </Box>

//       <Box sx={STYLES.cardsContainer}>
//         {automationOptions.map((option) => {
//           const isActive = selectedOption === option.id;
//           const isLoading = isLoadingId === option.id;

//           return (
//             <Box
//               key={option.id}
//               onClick={() => handleSelect(option.id)}
//               sx={{
//                 ...STYLES.card.base,
//                 ...(isActive ? STYLES.card.active : {}),
//               }}
//             >
//               <Box sx={STYLES.checkbox} onClick={(e) => e.stopPropagation()}>
//                 <Checkbox
//                   checked={isActive}
//                   onChange={() => handleSelect(option.id)}
//                   shadow
//                   cursor="pointer"
//                 />
//               </Box>

//               <Box
//                 sx={{
//                   ...STYLES.iconSection,
//                   backgroundColor: option.bgColor,
//                 }}
//               >
//                 <Box sx={STYLES.iconCircle}>
//                   <Image src={option.iconComponent} />
//                 </Box>
//               </Box>

//               <Box sx={STYLES.textSection}>
//                 <TypographyInline
//                   size={"md"}
//                   color={isActive ? BRAND.PRIMARY : GREY.PRIMARY}
//                   fontWeight={fontWeight.SEMIBOLD}
//                   label={option.title}
//                 />
//                 <TypographyInline
//                   size={"sm"}
//                   color={GREY.QUATINARY}
//                   fontWeight={fontWeight.REGULAR}
//                   label={option.description}
//                 />
//               </Box>

//               <Box sx={STYLES.buttonSection}>
//                 <Button
//                   label={
//                     isLoading ? (
//                       <CircularProgress size={18} color="inherit" />
//                     ) : isActive ? (
//                       "Generate"
//                     ) : (
//                       `Select ${option.title}`
//                     )
//                   }
//                   variant={isActive ? "primary" : "ghost"}
//                   size={"sm36"}
//                   fullWidth
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     if (!isActive) {
//                       handleSelect(option.id);
//                     } else {
//                       handleGenerate(option.id);
//                     }
//                   }}
//                   disabled={isLoading}
//                 />
//               </Box>
//             </Box>
//           );
//         })}
//       </Box>
//     </Box>
//   );

//   return (
//     <CustomModal
//       open={open}
//       close={handleClose}
//       header={modalHeaderData}
//       children={modalBodyData}
//       width={"900px"}
//     />
//   );
// };

// export default CreateAutomation;

import React, { useState } from "react";
import { Box } from "@mui/material";
import CustomModal from "../../../../components/Modals/CustomModal";
import { fontWeight } from "../../../../utils/constants/UI";
import { GREY, BRAND, BORDER } from "../../../../utils/constants/colors";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import Image from "../../../../components/Image/Image";
import classes from "../markComponents.module.css";
import {
  AUTOMATED_IMAGE,
  CALL_IMAGE,
  TODO_IMAGE,
} from "../../../../utils/constants/assets";
import { postRequest } from "../../../../Apis";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateAvailableCredits } from "../../../../redux/actions/authActions";
import { CircularProgress } from "@mui/material";
import { sequenceEndPoints } from "../../../../utils/constants/httpConstants";
import Checkbox from "../../../../components/Buttons/Checkbox/Checkbox";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { EMITTER_SUCCESS, EMITTER_ERROR } from "../../../../utils/constants";

const STYLES = {
  modalBody: {
    padding: "20px",
  },
  description: {
    marginBottom: "24px",
  },
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
  },
  card: {
    base: {
      cursor: "pointer",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      borderRadius: "16px",
      border: `1px solid ${BORDER.DEFAULT}`,
      backgroundColor: "#FFFFFF",
      transition: "all 0.2s ease",
      overflow: "hidden",
    },
    active: {
      border: `1px solid ${BRAND.PRIMARY}`,
      backgroundColor: "#FFFFFF",
    },
  },
  checkbox: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 10,
  },
  iconSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px 32px",
  },
  iconCircle: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  },
  textSection: {
    padding: "0 24px 24px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  buttonSection: {
    padding: "0 20px 20px",
  },
};

// Updated: Added stepNumber to props
const CreateAutomation = ({
  open,
  setOpen,
  handleClose,
  seqId,
  stepNumber,
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoadingId, setIsLoadingId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const automationOptions = [
    {
      id: "automated_email",
      title: "Automated Email",
      description: "Create email to be sent based on triggers",
      iconComponent: AUTOMATED_IMAGE,
      bgColor: "#FEFEFE",
    },
    {
      id: "call",
      title: "Call",
      description: "Create call tasks and reminders",
      iconComponent: CALL_IMAGE,
      bgColor: "#FEFEFE",
    },
    {
      id: "todo",
      title: "To-do",
      description: "Create task lists and reminders",
      iconComponent: TODO_IMAGE,
      bgColor: "#FEFEFE",
    },
  ];

  const handleSelect = (id) => {
    setSelectedOption(id);
  };

  const handleGenerate = async (id) => {
    if (!seqId) {
      EventEmitter.emit(
        EMITTER_ERROR,
        "Sequence ID is missing. Please try again.",
      );
      return;
    }

    setSelectedOption(id);
    setIsLoadingId(id);

    try {
      const resTypeMap = {
        automated_email: 1,
        call: 3,
        todo: 2,
      };

      const resType = resTypeMap[id];

      // Prepare the base payload
      const payload = {
        sequence_id: seqId,
        res_type: resType,
      };

      // NEW LOGIC: If stepNumber is provided (Insert Mode), add it to payload.
      // If stepNumber is undefined/null, API defaults to Append Mode.
      if (stepNumber) {
        payload.step_number = stepNumber;
      }

      const response = await postRequest(
        navigate,
        sequenceEndPoints.aiGenerateManualStep,
        payload,
      );

      if (response.data && response.data.success) {
        EventEmitter.emit(EMITTER_SUCCESS, response.data.message);
        dispatch(updateAvailableCredits(navigate));
        setTimeout(() => {
          handleClose();
        }, 1500);
      } else {
        EventEmitter.emit(
          EMITTER_ERROR,
          "Failed to generate automation step. Please try again.",
        );
      }
    } catch (err) {
      console.error("API error:", err);
      EventEmitter.emit(
        EMITTER_ERROR,
        err?.data?.message ||
          "An error occurred while generating automation step.",
      );
    } finally {
      setIsLoadingId("");
    }
  };

  const modalHeaderData = {
    heading: {
      id: "automation_head",
      label: "Create Automation",
    },
  };

  const modalBodyData = (
    <Box sx={STYLES.modalBody}>
      <Box sx={STYLES.description}>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.REGULAR}
          label="Select the type of automation you want to create for your sequence"
        />
      </Box>

      <Box sx={STYLES.cardsContainer}>
        {automationOptions.map((option) => {
          const isActive = selectedOption === option.id;
          const isLoading = isLoadingId === option.id;

          return (
            <Box
              key={option.id}
              onClick={() => handleSelect(option.id)}
              sx={{
                ...STYLES.card.base,
                ...(isActive ? STYLES.card.active : {}),
              }}
            >
              <Box sx={STYLES.checkbox} onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  checked={isActive}
                  onChange={() => handleSelect(option.id)}
                  shadow
                  cursor="pointer"
                />
              </Box>

              <Box
                sx={{
                  ...STYLES.iconSection,
                  backgroundColor: option.bgColor,
                }}
              >
                <Box sx={STYLES.iconCircle}>
                  <Image src={option.iconComponent} />
                </Box>
              </Box>

              <Box sx={STYLES.textSection}>
                <TypographyInline
                  size={"md"}
                  color={isActive ? BRAND.PRIMARY : GREY.PRIMARY}
                  fontWeight={fontWeight.SEMIBOLD}
                  label={option.title}
                />
                <TypographyInline
                  size={"sm"}
                  color={GREY.QUATINARY}
                  fontWeight={fontWeight.REGULAR}
                  label={option.description}
                />
              </Box>

              <Box sx={STYLES.buttonSection}>
                <Button
                  label={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : isActive ? (
                      "Add Step"
                    ) : (
                      `Select ${option.title}`
                    )
                  }
                  variant={isActive ? "primary" : "ghost"}
                  size={"sm36"}
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isActive) {
                      handleSelect(option.id);
                    } else {
                      handleGenerate(option.id);
                    }
                  }}
                  disabled={isLoading}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );

  return (
    <CustomModal
      open={open}
      close={handleClose}
      header={modalHeaderData}
      children={modalBodyData}
      width={"900px"}
    />
  );
};

export default CreateAutomation;
